module.exports = __webpack_public_path__ + "static/media/All Music (Active).edb03701.svg";